import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import { ArtifactProps } from "@/types";
import {
  artifactApiStore,
  artifactSaveStore,
  layoutStore,
  permissionStore,
  traceSaveStore,
  viewsStore,
} from "@/hooks";
import { FlexBox, IconButton } from "@/components/common";


/**
 * Represents actions for an artifact.
 */
const __default__ = {
  name: "ArtifactTableRowActions",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    artifact: {}
  },
  setup(__props: any) {

const props = __props;

const displayActions = computed(() =>
  permissionStore.isAllowed("project.edit_data")
);

/**
 * Opens the edit artifact window.
 */
function handleEdit() {
  artifactSaveStore.openPanel({
    artifact: props.artifact,
  });
}

/**
 * Opens the delete artifact window.
 */
function handleDelete() {
  artifactApiStore.handleDelete(props.artifact);
}

/**
 * Opens tree view with the current artifact selected.
 */
function handleOpenTree(): void {
  viewsStore.addDocumentOfNeighborhood(props.artifact);
  layoutStore.mode = "tree";
}

/**
 * Opens the create trace link panel with this artifact as the child.
 */
function handleLinkParent(): void {
  traceSaveStore.openPanel({
    type: "source",
    artifactId: props.artifact.id,
  });
}

/**
 * Opens the create trace link panel with this artifact as the parent.
 */
function handleLinkChild(): void {
  traceSaveStore.openPanel({
    type: "target",
    artifactId: props.artifact.id,
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(FlexBox), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IconButton), {
        icon: "view-tree",
        tooltip: `View artifacts related to '${_ctx.artifact.name}'`,
        "data-cy": "button-artifact-tree-icon",
        onClick: handleOpenTree
      }, null, 8, ["tooltip"]),
      (displayActions.value)
        ? (_openBlock(), _createBlock(_unref(IconButton), {
            key: 0,
            icon: "trace",
            rotate: -90,
            tooltip: `Add parent to '${_ctx.artifact.name}'`,
            "data-cy": "button-artifact-parent-icon",
            onClick: handleLinkParent
          }, null, 8, ["tooltip"]))
        : _createCommentVNode("", true),
      (displayActions.value)
        ? (_openBlock(), _createBlock(_unref(IconButton), {
            key: 1,
            icon: "trace",
            rotate: 90,
            tooltip: `Add child to '${_ctx.artifact.name}'`,
            "data-cy": "button-artifact-child-icon",
            onClick: handleLinkChild
          }, null, 8, ["tooltip"]))
        : _createCommentVNode("", true),
      (displayActions.value)
        ? (_openBlock(), _createBlock(_unref(IconButton), {
            key: 2,
            icon: "edit",
            tooltip: `Edit '${_ctx.artifact.name}'`,
            "data-cy": "button-artifact-edit-icon",
            onClick: handleEdit
          }, null, 8, ["tooltip"]))
        : _createCommentVNode("", true),
      (displayActions.value)
        ? (_openBlock(), _createBlock(_unref(IconButton), {
            key: 3,
            icon: "delete",
            tooltip: `Delete '${_ctx.artifact.name}'`,
            "data-cy": "button-artifact-delete-icon",
            onClick: handleDelete
          }, null, 8, ["tooltip"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})